import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/primitives";
import { NEWS } from "@/content/worldFarmers";

export const NewsV2 = () => {
  const featured = NEWS.find((n) => n.featured) || NEWS[0];
  const rest = NEWS.filter((n) => n.id !== featured.id);
  return (
    <section id="news" aria-labelledby="news-v2-heading" className="wf-section bg-[var(--wf-cream)]">
      <div className="wf-container">
        <Reveal className="flex items-end justify-between gap-4">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--wf-maroon)]">
              In the news
            </span>
            <h2 id="news-v2-heading" className="mt-3 font-serif text-3xl font-semibold text-[var(--wf-ink)] sm:text-4xl lg:text-5xl">
              Announcements &amp; stories
            </h2>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {/* Featured (tall) */}
          <Reveal className="lg:col-span-1 lg:row-span-2">
            <a href={featured.href} target="_blank" rel="noopener noreferrer" data-testid="news-featured-card" className="group relative flex h-full min-h-[420px] flex-col justify-end overflow-hidden rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background">
              <img src={featured.image} alt={featured.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[800ms] group-hover:scale-105" />
              <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
              <div className="relative p-6">
                <div className="flex items-center gap-3">
                  <span className="rounded-full bg-[var(--wf-clay)]/90 px-2.5 py-0.5 text-[11px] font-semibold text-white">{featured.category}</span>
                  <span className="text-xs text-white/70">{featured.date}</span>
                </div>
                <h3 className="mt-3 font-serif text-2xl font-semibold text-white">{featured.title}</h3>
                <p className="mt-2 text-sm leading-6 text-white/80">{featured.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-white">Read more <ArrowUpRight className="h-4 w-4 motion-safe:transition-transform motion-safe:group-hover:translate-x-0.5 motion-safe:group-hover:-translate-y-0.5" aria-hidden="true" /></span>
              </div>
            </a>
          </Reveal>

          {/* Secondary cards */}
          {rest.map((n, idx) => (
            <Reveal key={n.id} delay={0.08 * (idx + 1)} className="lg:col-span-2">
              <a href={n.href} target="_blank" rel="noopener noreferrer" data-testid="news-item-card" className="group flex gap-5 overflow-hidden rounded-sm border border-[var(--wf-border)] bg-[var(--wf-paper)] p-3 shadow-[var(--wf-shadow-sm)] transition-[box-shadow,transform] duration-300 hover:shadow-[var(--wf-shadow)] motion-safe:hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background">
                <img src={n.image} alt={n.alt} loading="lazy" className="h-28 w-36 shrink-0 rounded-sm object-cover" />
                <div className="flex flex-col justify-center">
                  <div className="flex items-center gap-2">
                    <span className="rounded-full bg-[rgba(47,93,58,0.10)] px-2.5 py-0.5 text-[10px] font-semibold text-[var(--wf-green-text)]">{n.category}</span>
                    <span className="text-[11px] text-muted-foreground">{n.date}</span>
                  </div>
                  <h3 className="mt-1.5 font-serif text-lg font-semibold leading-snug text-[var(--wf-ink)] group-hover:text-[var(--wf-maroon)]">{n.title}</h3>
                  <p className="mt-1 line-clamp-2 text-sm leading-6 text-muted-foreground">{n.excerpt}</p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
